import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/einstellungen/datenschutz')({
  head: () => noIndexRouteHead('settingsPrivacy', 'de'),
  component: () => <SettingsPage section="datenschutz" />,
})
